
import axios from "../services/AxiosInstance";

export const getTransactionHistoryService = async (patient_id) => {
  const response = await axios.post("/patient/transactionHistory", { patient_id });
  return response.data;
};

